/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './icd-10-diagnosis.reducer';

export const ICD10DiagnosisDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const iCD10DiagnosisEntity = useAppSelector(state => state.iCD10Diagnosis.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="iCD10DiagnosisDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.iCD10Diagnosis.detail.title">ICD10Diagnosis</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.iCD10Diagnosis.id">Id</Translate>
            </span>
          </dt>
          <dd>{iCD10DiagnosisEntity.id}</dd>
          <dt>
            <span id="dxId">
              <Translate contentKey="tinyMedicRestApp.iCD10Diagnosis.dxId">Dx Id</Translate>
            </span>
          </dt>
          <dd>{iCD10DiagnosisEntity.dxId}</dd>
          <dt>
            <span id="code">
              <Translate contentKey="tinyMedicRestApp.iCD10Diagnosis.code">Code</Translate>
            </span>
          </dt>
          <dd>{iCD10DiagnosisEntity.code}</dd>
          <dt>
            <span id="formattedCode">
              <Translate contentKey="tinyMedicRestApp.iCD10Diagnosis.formattedCode">Formatted Code</Translate>
            </span>
          </dt>
          <dd>{iCD10DiagnosisEntity.formattedCode}</dd>
          <dt>
            <span id="validForCoding">
              <Translate contentKey="tinyMedicRestApp.iCD10Diagnosis.validForCoding">Valid For Coding</Translate>
            </span>
          </dt>
          <dd>{iCD10DiagnosisEntity.validForCoding ? 'true' : 'false'}</dd>
          <dt>
            <span id="shortDesc">
              <Translate contentKey="tinyMedicRestApp.iCD10Diagnosis.shortDesc">Short Desc</Translate>
            </span>
          </dt>
          <dd>{iCD10DiagnosisEntity.shortDesc}</dd>
          <dt>
            <span id="longDesc">
              <Translate contentKey="tinyMedicRestApp.iCD10Diagnosis.longDesc">Long Desc</Translate>
            </span>
          </dt>
          <dd>{iCD10DiagnosisEntity.longDesc}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.iCD10Diagnosis.active">Active</Translate>
            </span>
          </dt>
          <dd>{iCD10DiagnosisEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="revision">
              <Translate contentKey="tinyMedicRestApp.iCD10Diagnosis.revision">Revision</Translate>
            </span>
          </dt>
          <dd>{iCD10DiagnosisEntity.revision}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.iCD10Diagnosis.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{iCD10DiagnosisEntity.microSec}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.iCD10Diagnosis.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{iCD10DiagnosisEntity.lastupdated}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.iCD10Diagnosis.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{iCD10DiagnosisEntity.timestampentry}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.iCD10Diagnosis.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{iCD10DiagnosisEntity.cursor}</dd>
        </dl>
        <Button tag={Link} to="/icd-10-diagnosis" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/icd-10-diagnosis/${iCD10DiagnosisEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default ICD10DiagnosisDetail;
